import React from 'react';
import type { SurveyResponseField, SurveyResponsePlan } from './printSurveyResponseTemplates';
import { PrintSurveyQuestionForm } from './PrintSurveyQuestionForm';

interface PrintSurveyResponseFormProps {
  plan: SurveyResponsePlan;
  optionCount?: number;
}

function PrintSurveyField({ field }: { field: SurveyResponseField }) {
  const isNumber = field.kind === 'number';

  return (
    <div
      className={`print-survey-response__field${
        isNumber ? ' print-survey-response__field--number' : ''
      }`}
    >
      <p className="print-survey-response__label">{field.label}</p>
      <div
        className={`print-survey-response__inputs${
          isNumber ? ' print-survey-response__inputs--compact' : ''
        }`}
        aria-hidden
      >
        {Array.from({ length: field.lines }, (_, index) => (
          <span
            key={index}
            className={
              isNumber
                ? 'print-survey-response__number-slot'
                : 'print-survey-response__line'
            }
          />
        ))}
      </div>
    </div>
  );
}

export function PrintSurveyResponseForm({ plan, optionCount = 4 }: PrintSurveyResponseFormProps) {
  if (plan.template === 'question_with_options') {
    return <PrintSurveyQuestionForm optionCount={optionCount} />;
  }

  if (plan.template === 'ordered_frequencies') {
    return (
      <div className="print-survey-response print-survey-response--ranked">
        <p className="print-survey-response__hint">
          Escribe la cantidad de votos de cada opción, ordenadas de mayor a menor.
        </p>
        <div className="print-survey-response__rank-grid">
          {plan.fields.map((field) => (
            <div key={field.id} className="print-survey-response__rank-cell">
              <span className="print-survey-response__rank-label">{field.label}</span>
              <span className="print-survey-response__number-slot" aria-hidden />
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (plan.template === 'writing_lines') {
    return (
      <div className="print-writing-lines" aria-hidden>
        {Array.from({ length: plan.lineCount }).map((_, index) => (
          <div key={index} className="print-writing-line" />
        ))}
      </div>
    );
  }

  return (
    <div className="print-survey-response">
      {plan.fields.map((field) => (
        <PrintSurveyField key={field.id} field={field} />
      ))}
    </div>
  );
}
